import { Configuration, Proceso, ProcesoApi } from '@/shared/formalizacion-client';
import { AxiosResponse } from 'axios';
import { Store } from 'vuex';

export default class ProcesoService extends ProcesoApi {
  constructor(microserviceConfigFormalizacion: Configuration, private store: Store<any>) {
    super(microserviceConfigFormalizacion);
  }

  private get proceso(): Proceso {
    return this.store.getters.proceso;
  }

  public getProceso(clave: string): Promise<AxiosResponse<Proceso>> {
    const response = super
      .getProceso(clave)
      .then(res => {
        this.store.commit('setProceso', res.data);
        return Promise.resolve(res);
      })
      .catch(err => {
        return Promise.reject(err);
      });
    return response;
  }

  public getActualProceso(): Proceso {
    return this.proceso;
  }

  public getActualProcesoClave(): string {
    return this.proceso.clave;
  }
}
